import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-terminos-condiciones-app',
  templateUrl: './terminos-condiciones-app.component.html',
  styleUrls: ['./terminos-condiciones-app.component.scss']
})
export class TerminosCondicionesAppComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  irAUrlAnterior() {
    this.location.back();
  }

}
